import { setRange } from './helpers';

export const setFloors = setRange('floorn');
